/* src/Components/NotificationIcon.js */
import React from 'react';
import { 
  FiAlertTriangle, // alerts
  FiDollarSign,    // bids
  FiUser,          // account
  FiLifeBuoy,      // support
  FiClock,         // deadline
  FiCreditCard,    // payment
  FiInfo,          // system
  FiXSquare,       // task_disputed
  FiCheckSquare,   // task_completed
  FiClipboard,     // task_assigned
  FiHelpCircle     // default
} from 'react-icons/fi';

const NotificationIcon = ({ type }) => {
  const baseClasses = "h-6 w-6 text-white";
  let icon;
  let bgClass;

  switch (type) {
    case 'alerts':
      icon = <FiAlertTriangle className={baseClasses} />;
      bgClass = 'bg-red-500';
      break;

    case 'bids':
      icon = <FiDollarSign className={baseClasses} />;
      bgClass = 'bg-green-500';
      break;

    case 'account':
      icon = <FiUser className={baseClasses} />;
      bgClass = 'bg-blue-500';
      break;

    case 'support':
      icon = <FiLifeBuoy className={baseClasses} />;
      bgClass = 'bg-purple-500';
      break;

    case 'deadline':
      icon = <FiClock className={baseClasses} />;
      bgClass = 'bg-orange-500';
      break;

    case 'payment':
      icon = <FiCreditCard className={baseClasses} />;
      bgClass = 'bg-green-500';
      break;

    case 'system':
      icon = <FiInfo className={baseClasses} />;
      bgClass = 'bg-gray-500';
      break;

    case 'task_disputed':
      icon = <FiXSquare className={baseClasses} />;
      bgClass = 'bg-red-500';
      break;

    case 'task_completed':
      icon = <FiCheckSquare className={baseClasses} />;
      bgClass = 'bg-green-500';
      break;

    case 'task_assigned':
      icon = <FiClipboard className={baseClasses} />;
      bgClass = 'bg-blue-500';
      break;

    default: // A safe fallback
      icon = <FiHelpCircle className={baseClasses} />;
      bgClass = 'bg-gray-400';
      break;
  }

  return (
    <div className={`w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center ${bgClass}`}>
      {icon}
    </div>
  );
};

export default NotificationIcon;